import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_ConsentForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_ConsentForm' className='file-pdf-document'>

            <div className='file-template'>

                <h2>(1) INTRODUCTION OF COMPANY AND SERVICES</h2>
                <p className='w-750'>
                    <b>OUR FAMILY:</b> New Heights Behavioral Consultants, Inc. is a registered
                    Georgia for-profit corporation and a provider of Tier 2 Comprehensive
                    Outpatient Resource Environment (CORE) Services.  Our staff includes
                    a Chief Executive Officer, Executive Director, Clinical Director,
                    Program Manager, Assistant Program Manager/Utilization Manager,
                    Licensed Therapists, Nursing Staff, Medical Staff Physicians,
                    Paraprofessionals, Case Managers, Intake & Referral Staff and an
                    Office Administrator.
                </p>
                <p className='w-750'>
                    <b>OUR VISION:</b> We believe that every child and family should
                    have a balanced and happy life. Therefore, our vision is to "restore
                    balance and harmony" to the lives of our families through the use of
                    quality counseling services.
                </p>
                <p className='w-750'>
                    <b>OUR MISSION:</b> Our mission is to educate, empower, and to
                    expand the provision of effective counseling techniques and
                    interventions to address the specific needs of individuals and
                    families; through culturally specific, clinically relevant
                    strategies and practices that wholistically meets their needs.
                    The results is restoring balance and harmony to life and living
                    one step at a time.
                </p>
                <p className='w-750'>
                    <b>TIER 2 CORE SERVICES:</b> CORE attempts to provide families
                    with the knowledge, skills, and abilities to improve family
                    communication, relations and strengthen families through
                    structured interventions and skill building strategies that
                    decrease individual and family risk factors.
                </p>
                <p className='w-750'>
                    <b>CORE services include but are not limited to the following:</b>
                </p>
                <p className='w-750'>
                    <ul >
                        <li>Physician's Assessment and Care</li>
                        <li>Nursing Assessment and Care</li>
                        <li>Diagnostic Assessment and Individualized Recovery/Resiliency Planning</li>
                        <li>CSI (Community Support Individual)/Psychosocial Rehabilitation and/or Case Management</li>
                        <li>Individual, Family, & Group Training/Counseling</li>
                        <li>Parenting Skills Training</li>
                        <li>Peer Services, Mentoring, Tutoring, Behavioral Assistance, Structured Activity Supports, and other services</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b>CORE TREATMENT:</b>  These services are designed specifically to
                    meet the needs of each individual client and his/her situation.
                    These medical, therapeutic & case management services are provided
                    by or under the supervision of licensed medical & clinical staff
                    with the capacity to address the individual's therapeutic and
                    environmental issues in order to stabilize a situation as soon
                    as possible and to promote recovery.  These services are both
                    individual/family focused, strength oriented, active and
                    rehabilitative, & delivered primarily in the office environment
                    during scheduled appointment times in various time increments.
                    These services are provided face to face with the individual,
                    couple, family or group.  As an additional support, New Heights
                    has access to additional medical, psychiatric, psychological,
                    and nursing services provided by a Physician, Psychiatrist,
                    Licensed Psychologist, and/or Registered Nurse.  Additionally,
                    supports are provided through case management services supplied
                    to individuals in their home, school, or community. These
                    services link individuals to the most appropriate resources available.
                </p>
                <p className='w-750'><b>BENEFITS OF TIER 2 CORE SERVICES:</b></p>
                <p className='w-750'>
                    <ul>
                        <li>Improving client's self-concept and self-control, emotional self-regulation, anger expression</li>
                        <li>Reducing behavior problems, substance use, and association with antisocial peers </li>
                        <li>Increasing parental involvement and development of more positive and effective parenting </li>
                        <li>Making parental management of children's behavior more effective</li>
                        <li>Improving family structure and interactions</li>
                        <li>Improving family communication, conflict resolution, and problem solving skills</li>
                        <li>Improving personal objectives through processing both individual and family needs with therapist</li>
                    </ul>

                </p>
                <h2>(2) LIMITS OF CONFIDENTIALITY </h2>
                <p className='w-750'>
                    The contents of therapy, counseling, intake, or assessment sessions
                    are considered to be confidential. Both verbal information and written
                    records about a client cannot be shared with another party without
                    the written consent of the client or the client's legal guardian. It
                    is the policy of New Heights Behavioral Consultants, Inc. not to
                    release any information about a client without a signed release of
                    information.  (See Client Handbook) Noted exceptions are as follows:
                </p>
                <p className='w-750'><b>1. Duty to Warn and Protect</b></p>
                <p className='w-750'>
                    When a client discloses intentions or a plan to harm another person,
                    we are required to warn the intended victim and report this
                    information to legal authorities. In cases in which the client
                    discloses or implies a plan for suicide, we are required to
                    notify legal authorities and make reasonable attempts to notify
                    the family of the client.
                </p>
                <p className='w-750'><b>2. Abuse of Children and Vulnerable Adults</b></p>
                <p className='w-750'>
                    If adult states or suggests that he or she is abusing a child
                    (or vulnerable adult) or has recently abused a child (or
                    vulnerable adult), or a child (or vulnerable adult) is in
                    danger of abuse, we are required to report this information
                    to the appropriate social service and/or legal authorities.
                </p>
                <p className='w-750'><b>3. Prenatal Exposure to Controlled Substances</b></p>
                <p className='w-750'>
                    We are required to report admitted prenatal exposure to controlled
                    substances that are potentially harmful.
                </p>
                <p className='w-750'><b>4. In the Event of a Client's Death</b></p>
                <p className='w-750'>
                    In the event of client's death, the spouse or parents of a deceased
                    client have right to access their child or spouse's records as
                    defined by HIPPA.
                </p>
                <p className='w-750'><b>5. Professional Misconduct</b></p>
                <p className='w-750'>
                    Our team members must report professional misconduct by any of the
                    other team members. In cases in which a professional or legal
                    disciplinary meeting is being held regarding the actions of team
                    member, related records may be released in order to substantiate
                    disciplinary concerns.
                </p>

                <p className='w-750'><b>6. Court Orders</b></p>
                <p className='w-750'>
                    We are required to release records of clients when a court order
                    has been placed. Client's who are on probation, court ordered to
                    treatment or referred by the Department of Juvenile Justice,
                    Department of Human Services or the Department of Justice or any court services at NHBC may
                    have waived certain rights to confidentiality when entering the
                    CORE program.
                </p>

                <p className='w-750'><b>7. Minors/Guardianship</b></p>
                <p className='w-750'>
                    Parents or legal guardians of non-emancipated minor clients have
                    the right to access the client's records.
                </p>
                <p className='w-750'><b>8. Audio/Video Taping</b></p>
                <p className='w-750'>
                    In the event it becomes necessary to audio and/or video tape a client
                    for treatment or supervision purposes, a specific consent form for
                    the purpose of audio and/or video will be required. No recordings of
                    any kind will be conducted without the expressed consent of the client.
                </p>
                <p className='w-750'><b>9. Drugs & Weapons in client's home</b></p>
                <p className='w-750'>
                    Our clinicians are required to report any illicit drugs or weapons
                    that they notice at client's home.
                </p>
                <p className='w-750'><b>10. Other Provisions</b></p>
                <p className='w-750'>
                    New Heights Behavioral Consultants, LLC does not conduct research
                    on any of their clients. Outcome measures, pertaining to the
                    effectiveness of the CORE Services Program, are collected and
                    analyzed to ensure that the best quality treatment is provided.
                    No personal information on any client is disclosed, nor can any
                    client be identified by any of outcome information collected by
                    external entities through granting sources.
                </p>
                <p className='w-750'>
                    Information about clients may be disclosed in consultations
                    with other professionals in order to provide the best possible
                    treatment. In such cases the name of the client, or any
                    identifying information, is not disclosed.
                </p>
                <p className='w-750'>
                    The material disclosed in conjoint family or couples sessions,
                    in which each party discloses such information in each other's
                    presence, is kept in file in the form of case notes.
                </p>
                <p className='w-750'>
                    In the event we must communicate via telephone or other electronic communication to the client for purposes
                    such as appointment cancellations or reminders, or to give/receive
                    other information, efforts are made to preserve confidentiality.
                </p>
                <h2>3) CLIENT'S BILL OF RIGHTS AND RESPONSIBILITIES FOR INDIVIDUALS SERVED</h2>
                <p className='w-750'><b>I. 	Information Disclosure (see client handbook)</b></p>
                <p className='w-750'>
                    Consumers have the right to receive accurate, easily understood
                    information. We will make any reasonable effort to accommodate
                    consumers that might require assistance in making informed mental
                    health care decisions about their services and professionals
                    serving them.
                </p>
                <p className='w-750'><b>II. 	Choice of Providers</b></p>
                <p className='w-750'>
                    Consumers have the right to a choice of provider (when available),
                    in order to ensure access to appropriate high quality care. If you
                    would like to contact another provider, with the approval of the
                    agency, you will be furnished a list of other providers providing
                    similar services.
                </p>
                <p className='w-750'><b>III. 	Access to Emergency Services</b></p>
                <p className='w-750'>
                    Consumers have the right to access services 24 hours/day, 7
                    days/week in case of an emergency.  New Heights Behavioral
                    Consultants LLC., in partnership with Behavioral Health Link
                    (BHL) provides these crisis services through the Georgia Crisis
                    & Access line whose number is 1-800-715-4225.
                </p>
                <p className='w-750'><b>IV. 	Participation in Treatment Decisions</b></p>
                <p className='w-750'>
                    Consumers and parents/guardians have the right and responsibility
                    to fully participate in all decisions related to services.
                    Consumers who are unable to fully participate in treatment
                    decisions have the right to be represented by parents,
                    guardians, family members, or other legal entities. Clients
                    have the right to discuss any treatment concerns with therapist,
                    paraprofessional, or clinical director.
                </p>
                <p className='w-750'>
                    <b>V. 	Respect and Nondiscrimination</b>
                </p>
                <p className='w-750'>
                    Consumers must not be discriminated against in the delivery of
                    services based on race, ethnicity, national origin, religion,
                    sex, age, mental or physical disability, sexual orientation,
                    genetic information, or source of payment. Clients and their
                    families have the right to be treated with courtesy, respect
                    and dignity at all times. Limitations to access to service do
                    not infer or result in discrimination. These limitations (i.e.
                    inability to effectively treat psychotic participants with active
                    hallucinations, delusions, patients under the influence of drugs
                    during the majority face-to-face contacts, families without
                    stable housing, autistic patients and children and adolescents
                    without parent/guardian, sexual offenders who are predatory)
                    are discussed with referring agencies and clients/families.
                    NHBC, Inc. will not discharge client because of the inability
                    to get reimbursed for services due to lapse in Medicaid or
                    Peachcare insurance coverage.
                </p>
                <p className='w-750'><b>VI. 	Complaints and Appeals</b></p>
                <p className='w-750'>
                    Consumers have the right to a fair and efficient process for
                    resolving disputes and differences with provider. Clients
                    have the right to communicate freely with the therapist,
                    therapist assistant, supervisor and clinical director.
                    Client's complaint form is available upon request from the
                    therapist or therapist assistant as per our Policy and
                    Procedure #100-40-2   If therapist or therapist assistant
                    refuses to provide client with the complaint form, please
                    contact Quality Assurance Coordinator at 770-460-0970.
                </p>
                <p className='w-750'><b>VII. Other Client's Rights</b></p>
                <p className='w-750'>
                    Clients and their families have the right to have all
                    program rules conveyed in an understandable manner. Clients
                    have the right to have rights explained to them in a
                    language they understand.
                </p>
                <p className='w-750'><b>VIII. Consumer Responsibilities</b></p>
                <p className='w-750'>
                    It is reasonable to expect and encourage consumers to
                    assume reasonable responsibilities. Greater individual
                    involvement by consumers in their care increases the
                    likelihood of achieving the best outcomes and helps
                    support a quality improvement, cost-conscious environment.
                    Those responsibilities include:
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Clients have the responsibility to be a full participant in the formulation of their Treatment Plan. </li>
                        <li>Clients, have the responsibility to follow their Treatment Plan and take any prescribed medications in order to advance in treatment. </li>
                        <li>Clients have the responsibility to provide the service delivery staff with all required information to maintain proper and correct records.</li>
                        <li>Clients have the responsibility to keep their appointments and be on time. </li>
                        <li>Clients have the responsibility to treat their therapist or paraprofessional with dignity and respect. </li>
                        <li>Client's performance during the treatment will be reported to the referral source including probation officers on regular basis. </li>
                    </ol>
                </p>
                <p className='w-750'><b>IX. 	Right to have access to legal entities for appropriate representation</b></p>
                <p className='w-750'>
                    Clients can receive legal help through the State of Georgia, Office
                    of the Child Advocate that can be reached at 1-800 254-2064.
                </p>
                <p className='w-750'><b>X. 	Right to have access to self-help and advocacy support services</b></p>
                <p className='w-750'>
                    Clients can receive advocacy support services through the Department
                    of Human Resources, Consumer Advocacy Department that can be reached
                    at 770 720-3610.
                </p>
                <p className='w-750'><b>XI. 	Right to obtain the highly ethical services that is compliant with ethical standards of the American Psychological Associations (APA)</b></p>
                <p className='w-750'>
                    Clients should receive the treatment that follows the highest
                    ethical standards. Our clinicians do not smoke during the
                    sessions with client and families. They do not use seclusion
                    or restraint during the treatment.
                </p>
                <h3>Client Advocacy </h3>
                <p className='w-750'>
                    An intricate part of working with your family is building resiliency.
                    As part of that process New Heights Behavioral Consultants, Inc.
                    will assist you in becoming aware of your rights while in treatment
                    and to locate agencies and organizations that can assist you in
                    protecting those rights.
                </p>
                <p className='w-750'>
                    As a client of New Heights Behavioral Consultants, Inc., you
                    have a right to expect advocacy in the following client rights
                    categories:
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Abuse and Neglect</li>
                        <ol>
                            <li>Physical Abuse</li>
                            <li>Verbal Abuse </li>
                            <li>Sexual abuse</li>
                            <li>Neglect</li>
                        </ol>
                        <li>Admission and Discharge</li>
                        <ol>
                            <li>Voluntary Admission *</li>
                            <li>Involuntary Admission </li>
                            <li>Periodic Review </li>
                            <li>Discharge</li>
                            <li>Community Placement</li>
                        </ol>
                        <li>Confidentiality</li>
                        <ol>
                            <li>Confidentiality</li>
                            <li>Disclosure of information </li>
                            <li>Access to Media</li>
                        </ol>
                        <li>Rights of the Person</li>
                        <ol>
                            <li>Dignity and Privacy </li>
                            <li>Education</li>
                            <li>Entitlements</li>
                            <li>Marriage and Divorce</li>
                            <li>Religion</li>
                            <li>Search</li>
                            <li>Sexuality/Birth Control</li>
                            <li>Smoking and Drinking </li>
                        </ol>
                        <li>Consent</li>
                        <ol>
                            <li>Competency</li>
                            <li>Substitute Consent/Guardianship </li>
                            <li>Obtaining Consent</li>
                            <li>What Needs Consent</li>
                            <li>Treatment</li>
                        </ol>
                        <li>Freedom of Movement </li>
                        <ol>
                            <li>Freedom of movement</li>
                            <li>Seclusion</li>
                            <li>Restraint</li>
                        </ol>
                        <li>Communication</li>
                        <ol>
                            <li>Telephone</li>
                            <li>Mail</li>
                            <li>Visits</li>
                            <li>Electronic</li>
                            <li>Telehealth</li>
                        </ol>
                        <li>Rights to Protection and Advocacy </li>
                        <ol>
                            <li>Notice of Rights </li>
                            <li>Compliant</li>
                            <li>Grievance</li>
                        </ol>
                        <li>Treatment</li>
                        <ol>
                            <li>Right to Treatment </li>
                            <li>Right to Refuse Treatment </li>
                            <li>Individual Plan of Service</li>
                            <li>Physical</li>
                            <li>Behavior Modification </li>
                            <li>Least Restrictive</li>
                            <li>Environment</li>
                        </ol>
                        <li>Personal Property and Money </li>
                        <li>Work and Compensation</li>
                        <li>Discrimination</li>
                        <li>Environment</li>
                    </ol>
                </p>
                <h2 >(4) PSYCHOTHERAPIST-PATIENT SERVICES AGREEMENT (HIPAA)</h2>
                <p className='w-750'>
                    This section of the document contains summary information about
                    the Health Insurance Portability and Accountability Act (HIPAA),
                    a federal law that provides new privacy protections and new
                    patient rights with regard to the use and disclosure of your
                    Protected Health Information (PHI) used for the purpose of
                    treatment, payment, and health care operations.
                </p>
                <p className='w-750'>
                    The law requires that we obtain your verbal or handwritten or elelctronic signature acknowledging that we have provided you with this information at the end of
                    this session. Although these documents are long and sometimes
                    complex, it is very important that you read them carefully
                    before our next session. We can discuss any questions you
                    have about the procedures at that time. When you sign this
                    document, it will also represent an agreement between us.
                    You may revoke this Agreement in writing at any time.
                </p>
                <h3>PROFESSIONAL RECORDS </h3>
                <p className='w-750'>
                    The laws and standards of our profession require that we keep Protected Health Information about you and your family in your Clinical Record. Except in unusual circumstances that involve danger to yourself and others and we believe that access is reasonably likely to cause substantial harm to you or other person, you may examine and/or receive a copy of your Clinical Record, if you request it in writing. Because these are professional records, they can be misinterpreted and/or upsetting to untrained readers.
                </p>
                <p className='w-750'>
                    For this reason, we recommend that you initially review your records in our presence, or have them forwarded to another mental health professional. If we refuse your request for access to your records, you have a right of review (except for information provided to us confidentially by others), which we will discuss with you upon request. In addition, we also keep a set of Psychotherapy/Progress Notes. These Notes are for our own use and are designed to assist us in providing you with the best treatment. While the contents of Psychotherapy Notes vary from client to client, they can include the contents of our conversations, our analysis of those conversations, and how they impact your therapy. These Psychotherapy/Progress Notes are kept separate from the rest of your Clinical Record.
                </p>
                <p className='w-750'>
                    Your Psychotherapy/Progress Notes are not available to you and cannot be sent to anyone else, including insurance companies without your written, signed Authorization. Insurance companies cannot require your authorization as a condition of coverage nor penalize you in any way for your refusal to provide it.
                </p>
                <h3>CLIENT RIGHTS </h3>
                <p className='w-750'>
                    HIPAA provides you with several new or expanded rights with regard to your Clinical Record and disclosures of protected health information. These rights include requesting that we
                </p>
                <p className='w-750'>
                    1) amend your record; 2) allow you to place restrictions on what information from your Clinical Record is disclosed to others; 3) provide you with accounting of most disclosures of protected health information that you have neither consented to nor authorized; 4) provide you with accounting of locations to which protected information disclosures are sent; 5) include any complaints you make about our policies and procedures in your records; 6) provide you with a paper or electronic copy of this Agreement and the attached Notice form, and our privacy policies and procedures.
                </p>
                <h3>MINORS & PARENTS </h3>
                <p className='w-750'>
                    Clients under 18 years of age who are not emancipated and their parents should be aware that the law allows parents to examine child's records unless we believe that doing so would endanger the child. Because privacy in therapy is often crucial to success, particularly with teenagers, it is our policy to request an agreement from parents that they consent to give up their access to their child's records. If they agree, during treatment, we will update the parents only about the progress of the child's treatment, and his/her attendance at sessions. We will also provide parents with a summary of treatment when it is complete. Other communication will require the child's Authorization, unless we feel that child is a danger for self or to someone else, in which case, we will notify the parents of our concern. Before releasing information to parents, we will discuss the matter with the child, and do our best to handle any objections he/she may have.
                </p>
                <h2>(5) Mental Health Advance Directive </h2>
                <p className='w-750'>
                    An advance instruction/ directive allows you to make a legal directive in the case of mental health treatment. This advance instruction is binding for twenty-four months (2 years) from the date that you specify your wishes. This is the only advance directive that requires periodic renewal. This document goes into effect when your doctor or mental health provider determines that you no longer understand the nature and consequences of proposed mental health treatment and that you cannot make decisions about that treatment. This document must be signed by you (or have someone sign the document in your presence and at your direction, if you are unable to sign). The signatures on this document must be witnessed by 2 qualified (*) adults, dated, and notarized.
                </p>
                <p className='w-750'>
                    The directive for mental health treatment allows you to make treatment and medication decisions if you should require admission to and retention in a facility for the care or treatment of mental illness. This directive allows you to further clarify your wishes in regard to mental health care and treatment. For more information regarding advance directives please contact:
                </p>
                <div>
                    <input type="radio" id="rbFrm_1" name="rbFrm" className='add-only' value="0" /> I do not wish to complete an Advance Directive
                    <br />
                    <input type="radio" id="rbFrm_2" name="rbFrm" className='add-only' value="1" /> I do wish to complete an Advance Directive
                </div>
                <h3>Client Advocacy Contact Information </h3>
                <p className='w-750'><b>Legal Issues:</b></p>
                <p className='w-750'>
                    <ul>
                        <li><b>Home Defense</b> (404) 524-5811</li>
                        <li><b>Family Law</b> (404) 524-5811</li>
                        <li><b>Seniors Legal Hotline</b> (404) 657-9915</li>
                        <li><b>Grandparents/Relative Caregiver Project</b> (404) 614-3911</li>
                        <li><b>Ombudsman (nursing Home Advocacy)</b> (404) 371-3800</li>
                        <li><b>Hispanic Outreach Law Project</b> (404) 377-5381</li>
                        <li><b>Aids Legal Project</b> (404) 614-3969</li>
                        <li><b>The Cancer and ALS Legal Project</b> (404) 614-3969</li>
                        <li><b>Health Law Partnership</b> (404) 785-2005</li>
                        <li><b>Probate Information Center (estate)</b> (404) 730-5985</li>
                        <li><b>Southern Juvenile Defender Center (Emory)</b> (404) 727-6235</li>

                    </ul>
                </p>
                <p className='w-750'><b>County Legal Aid Offices:</b></p>
                <p className='w-750'>
                    <ul>
                        <li><b>Clayton County</b> </li>
                        <li><b>Cobb County</b> (770) 528-2565</li>
                        <li><b>Dekalb County</b> (404) 377-0701</li>
                        <li><b>Fulton County</b>(404) 524-5811 </li>
                        <li><b>Gwinnett County</b> (678) 376-4545</li>
                    </ul>
                </p>
                <p className='w-750'><b>State Child Advocate:</b></p>
                <p className='w-750'>
                    <ul>
                        <li><b>Tom Rawlings</b> (800) 254-2064</li>
                        <li><b>Spanish Speaking Child Advocate</b> (478) 757-2661, ext. 20</li>
                    </ul>
                </p>
                <h2>(6) CONSENT/ASSENT TO TREATMENT (Return to Office)</h2>
                <p className='w-750'>
                    This form is to document that I,
                    <input type="text" id="txtFrm_3" name="txtFrm_3" className='add-only w-250 custom-add-only' /> (<input type="radio" id="rbFrm_4_1" name="rbFrm_4" className='add-only' value="0" /> Individual Served,
                    <input type="radio" id="rbFrm_4_2" name="rbFrm_4" className='add-only' value="1" /> Parent/Legal Guardian), give my permission and consent to therapist
                    and the other employees/contractors of New Heights Behavioral
                    Consultants, Inc., to provide treatment to
                    (Myself/Child/Grandchild/Individual under my custody).  I understand
                    that because of the counseling or therapy or other ancillary services,
                    I/He/She/We may experience emotional strain, feel worse during
                    treatment, and make life changes that could be distressing.
                </p>
                <p className='w-750'>
                    I understand that this therapist might or might not be providing an emergency service and I have been informed of whom to call in emergency or during weekend and evening hours. I understand that regular attendance will produce the maximum benefits but I or we am/are free to discontinue treatment at any time in writing to the Clinical Director or CEO.  If I decide to do so I will notify the therapist at least two weeks in advance so that effective planning for continued care could be implemented.
                </p>
                <p className='w-750'>
                    I understand that conversations with the therapist will almost always be confidential with the exception of situations mentioned in section 2. I further understand that therapist, by law, must report actual or suspected child or elder abuse to the appropriate authorities. In addition, the therapist has a legal responsibility to protect anyone I/he/she/we may threaten with violence, harmful or dangerous actions (including those to myself) and may break confidentially of communication if such a situation arises. I understand that the therapist will make reasonable efforts to resolve these situations before breaking confidentiality.
                </p>
                <p className='w-750'>
                    I know of no reason that client should not undertake this therapy and I agree to participate fully and voluntarily. I have read and understood the following forms and that I agree to abide by its terms during our professional relationship:
                </p>
                <p className='w-750'><b>Introduction of our company and services </b></p>
                <p className='w-750'>
                <ol>
                    <li>Client's Bill of Right</li>
                    <li>Limits of Confidentiality</li>
                    <li>HIPPA Form </li>
                    <li>Client Rights Complaint Form</li>
                    <li>Consent to Treatment </li>
                    <li>Orientation to Advocacy</li>
                    <li>Orientation to Mental Health Advance Directives</li>
                </ol>
                </p>
                <hr />
                <h2>USE THIS SPACE ONLY IF CLIENT/ LEGAL GUARDIAN REFUSES THE TREATMENT</h2>
                <p className='w-750'>
                    I voluntarily refuse the treatment of my child/grandchild and I am aware of legal and other implications related to my decision. I understand that the client needs to go through the new referral process if he or she is to re-enter the program.
                </p>
                <h2>AUTHORIZATION FOR RELEASE OF INFORMATION </h2>
                <h3>(For filing to the clinical file)</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual's Name</span>
                            <input type="text" id="txtIndName" name="txtIndName" className='add-only'/>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DOB</span>
                            <input type="date" id="txtDOB" name="txtDOB" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I hereby request and authorize the disclosure of records/information From: (Text Box to type into)  and their designated staff to release information to verbally or written or obtain written/verbal reports/evaluations from the agencies mentioned below:
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_1" name="cb_1" className='add-only' value="1" />
                    County School System
                    <input type="text" id="txt_1" name="txt_1" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_2" name="cb_2" className='add-only' value="1" />
                    Private Provider/PCP
                    <input type="text" id="txt_2" name="txt_2" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_3" name="cb_3" className='add-only' value="1" />
                    County Department of Juvenile Justice
                    <input type="text" id="txt_3" name="txt_3" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_4" name="cb_4" className='add-only' value="1" />
                    Hospital
                    <input type="text" id="txt_4" name="txt_4" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_5" name="cb_5" className='add-only' value="1" />
                    County Department of Family and Children Services
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_6" name="cb_6" className='add-only' value="1" />
                    Other
                    <input type="text" id="txt_6" name="txt_6" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_7" name="cb_7" className='add-only' value="1" />
                    County Health Department
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_8" name="cb_8" className='add-only' value="1" />
                    County Juvenile Court/Adult Court
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_9" name="cb_9" className='add-only' value="1" />
                    County Community Services Board
                    <input type="text" id="txt_9" name="txt_9" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_10" name="cb_10" className='add-only' value="1" />
                    Amerigroup
                    <input type="text" id="txt_10" name="txt_10" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_11" name="cb_11" className='add-only' value="1" />
                    Cenpatico
                    <input type="text" id="txt_11" name="txt_11" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_12" name="cb_12" className='add-only' value="1" />
                    Wellcare
                    <input type="text" id="txt_12" name="txt_12" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cb_13" name="cb_13" className='add-only' value="1" />
                    Community Representative
                    <input type="text" id="txt_13" name="txt_13" className='add-only' />
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_14" name="txt_14" className='add-only' />
                    I authorize the following information from my record and any specific portion thereof that may include the following: 0 Psychological evaluation(s), 0 Psychiatric evaluation(s), 0 Individual Education Plans (IEP), 0 Behavior Contracts, 0 Drug/Alcohol assessments, 0 Safety plans, all testing recommendations, 0 school records, 0 medical records, 0special education records, 0 grades, attendance, 0 discipline records, 0SST records and any other relevant or requested information for the purpose of: sharing information to ensure better coordinate services and treatment from agencies involved.
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_15" name="txt_15" className='add-only' />
                    I further authorize the disclosure of alcohol or drug abuse information, if any (Please see paragraph 2 below)
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_16" name="txt_16" className='add-only' />
                    I further authorize the disclosure of alcohol or drug abuse information, if any (Please see paragraph 2 below)
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_17" name="txt_17" className='add-only' />
                    I authorize the disclosure of information, if any, concerning testing for HIV(Human-immunodeficiency virus) and/or treatment for HIV/AIDS  (Acquired immune-deficiency syndrome) and any related conditions.
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_18" name="txt_18" className='add-only' />
                    I authorize these agencies to share information by telephone or other electronic communication. All information I hereby authorize to be obtained from this Agency, Department or Office will be held strictly confidential and cannot be released by the recipient without my written consent.
                </p>
                <ol>
                    <li>I understand that the information disclosed pursuant to this Authorization may be subject to re-disclosure by the recipient and no longer protected by federal privacy regulations or other applicable state and federal laws (except as set forth in paragraph 2 below)</li>
                    <li>I understand that, pursuant to 42 C.F.R. Part 2, alcohol and drug abuse records that I authorize to be disclosed pursuant to this document may not be further re-disclosed without my written consent, except by a court order that complies with the preconditions set forth at 42 C.F.R. 2.61 et seq., or the other limited circumstance specifically permitted by 42 C.F.R. Part 2. Any individual that makes such a disclosure in violation of these provisions may be reported to the United States Attorney and be subject to criminal penalties. </li>
                    <li>I understand that my healthcare provider will not condition my treatment, payment, or eligibility for any applicable benefits strictly on whether I provide authorization for the requested release of information. </li>
                    <li>I intend this document to be a valid authorization conforming to all requirements of the Privacy Rule and State law, and understand that my authorization will remain in effect for:
                        (Please check one below)
                    </li>
                </ol>
                <p className='w-750'>
                    <input type="text" id="txt_22" name="txt_22" className='add-only' />
                    I authorize these agencies to share information by phone, in person, fax and/or email contact. All information I hereby authorize to be obtained
                    from this Agency, Department or Office will be held strictly confidential and cannot be released by the recipient without my written consent. I
                    understand that this authorization will remain in effect for:
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbCheckBelow" name="cbCheckBelow" className='add-only' value="1" />12 months &nbsp;
                    <input type="checkbox" id="cbCheckBelow1" name="cbCheckBelow1" className='add-only' value="1" />or the period necessary to complete all transactions related to services provided to me.
                </p>
                <p className='w-750'>
                    <input type="text" id="txt_23" name="txt_23" className='add-only' />
                    I understand that unless otherwise limited by state or federal regulation and except to the extent that action has been taken which was based on my consent, I may withdraw this consent at any time.
                </p>
                <table>
                    <tr>
                        <td className='signature w-350'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-350'>Name of the Client (printed)</td>
                        <td className='small w-250'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-350'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-350'>Parent or Legal Guardian (printed)</td>
                        <td className='small w-250'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-350'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-350'>Assessor/Agency Staff (printed)</td>
                        <td className='small w-250'>Signature  w/ credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    USE THIS SPACE ONLY IF INDIVIDUAL SERVED/ PARENT/ LEGAL GUARDIAN WITHDRAWS CONSENT
                </p>
                <table>
                    <tr>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-600'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-150'>Date</td>
                        <td className='small w-600'>Signature of Individual Served/Parent/Legal Guardian</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
